import React from "react";

export default function DeleteIcon() {
  return (
    <img
      style={{
        display: "inline",
        width: "20px",
        cursor: "pointer",
      }}
      src={'/icons/delete.svg'}
    />
  );
}
